import { AddSpecialTopicDTO, AddSpecialTopicFormFields } from 'types';
import { parseEditSpecialTopicFormFieldsIntoUpdateSpecialTopicDTO } from './parseEditSpecialTopicFormFieldsIntoUpdateSpecialTopicDTO';

export const parseAddSpecialTopicFormFieldsIntoAddSpecialTopicDTO: (
    specialTopicFormFields: AddSpecialTopicFormFields,
) => AddSpecialTopicDTO = (specialTopicFormFields) => {
    const parsedUpdateSpecialTopicDTO =
        parseEditSpecialTopicFormFieldsIntoUpdateSpecialTopicDTO(specialTopicFormFields);

    return {
        teacherId: specialTopicFormFields.teacherId,
        ...parsedUpdateSpecialTopicDTO,
    };
};
